<template>
  <v-card :disabled="loading" class="pa-6" flat>
    <v-row>
      <v-col cols="12">
        <detect-file-uploading @change="handleFilesUpload" />
      </v-col>

      <v-col
        v-for="(video, i) in audios"
        :key="i"
        cols="12"
        md="6"
        xl="4"
        class="d-flex flex-wraper"
      >
        <audio-player
          :audioSound="false"
          :file="video"
          :title="video.name"
          height="160"
          class="mx-2"
        />
      </v-col>

      <v-col
        v-if="audios.length"
        cols="12"
        class="d-flex align-items-center justify-content-center"
      >
        <v-combobox
          v-model="n"
          :items="category"
          class="d-flex mt-6 align-items-center"
          outlined
          dense
        />
        <v-btn
          @click="submitFiles()"
          :loading="loading"
          color="green"
          outlined
          class="mr-2"
        >
          {{ $t("submit") }}
          <v-icon>mdi-music-note-plus</v-icon>
        </v-btn>
        <v-btn @click="audios = []" outlined color="red">
          {{ $t("cancel") }}
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { ir } from "../../../../../check_domain_ir";
import { mapGetters } from "vuex";
import detectFileUploading from "../../detectFileUploading.vue";
import AudioPlayer from "./audioPlayer.vue";
export default {
  components: { detectFileUploading, AudioPlayer },
  name: "uploadAudio",
  props: {
    category: Array,
    value: [Number, String],
  },

  data() {
    return {
      audios: [],
      n: this.$t("all"),
      loading: false,
      url: process.env.VUE_APP_ROBOT,
      errorSound: 0,
      succesSound: 0,
    };
  },

  watch: {
    audios(val) {
      val.map((item, i) => {
        if (
          this.coreUser.username !== "tt1" &&
          Math.round(item.size / 1024) > 81920
        ) {
          this.$toast.error(
            "شما نمیتوانید فایل صوتی بیشتر از ۸۰ مگابایت آپلودکنید"
          );
          this.audios = [];
        }
      });
    },
  },
  computed: {
    ...mapGetters("ribbon", {
      coreUser: "user",
    }),

    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    submitFiles(item = 0) {
      this.loading = true;

      if (this.n === "") {
        this.$toast.error("نام دسته خودرا وارد کنید.");
        this.loading = false;
      } else {
        let formData = new FormData();
        // if (this.coreUser.username === "tt1" && this.coreUser.id === 4) {
        //     formData.append("bracket", this.bracket ?? undefined);
        // }
        formData.append("category", this.n);
        formData.append("file", this.audios[item]);
        formData.append("type", "other");
        formData.append("file_type", "audio");
        const Token = localStorage.getItem("id_token");
        const local_url = ir(this.url);
        $.ajax({
          url: `${local_url}/files`,
          fn: this.submitFiles,
          params: [item],
          type: "POST",
          data: formData,
          headers: {
            Authorization: Token,
            ACCEPT: "application/json",
          },
          xhr: () => {
            let xhr = new window.XMLHttpRequest();
            xhr.upload.addEventListener(
              "progress",
              (evt) => {
                if (evt.lengthComputable) {
                  //   this.loadingValue[item] = (evt.loaded / evt.total) * 100;
                  this.$forceUpdate();
                }
              },
              false
            );
            return xhr;
          },
          contentType: false,
          processData: false,
          msg: this.audios.length <= item + 1 && this.errorSound === 0,
          reload: this,
        }).always((data) => {
          try {
            this.errorSound += 1;
          } catch (e) {
            // this.getImages();
          }

          item++;
          data.status === true ? this.succesSound++ : this.errorSound++;
          this.valueComputed = 3;
          this.audios = [];
          this.loading = false;
          this.$emit("update");
          if (this.audios.length > item) this.submitFiles(item);
        });
      }
    },
    handleFilesUpload(e) {
      this.audios = [];
      e.files.map((item) => {
        if (item.type.startsWith("audio/")) {
          this.audios.push(item);
        } else {
          this.$toast.error("شما نمیتوانید فایل غیر صوت وارد کنید");
        }
      });
    },
  },
};
</script>

<style>
.v-input >>> v-text-field__details {
  display: none;
}
</style>
